import React from "react";
import {
  FaGithub,
  FaGlobe,
  FaInstagram,
  FaLinkedin,
  FaPaintBrush,
  FaTelegramPlane,
  FaTiktok,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { SiArc, SiDribbble, SiFreelancer, SiUpwork } from "react-icons/si";

const Footer = () => {
  const year = new Date().getFullYear();
  const socialLinks = [
    {
      label: "X",
      href: "https://x.com/FawziBarry",
      icon: FaTwitter,
      color: "text-blue-600",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/fawzibarry",
      icon: FaLinkedin,
      color: "text-blue-400",
    },
    {
      label: "GitHub",
      href: "https://github.com/Fawzi-Barry",
      icon: FaGithub,
      color: "text-black",
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/fawzi__barry/",
      icon: FaInstagram,
      color: "text-pink-500",
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@fawzi_barry",
      icon: FaYoutube,
      color: "text-red-500",
    },
    {
      label: "TikTok",
      href: "https://www.tiktok.com/@fawzi_barry",
      icon: FaTiktok,
      color: "text-white",
    },
    {
      label: "WhatsApp",
      href: "https://wa.me/251944134328 ",
      icon: FaWhatsapp,
      color: "text-green-500",
    },
    {
      label: "Telegram",
      href: "https://t.me/Fawzi_Barry",
      icon: FaTelegramPlane,
      color: "text-sky-400",
    },
  ];
  const marketplaceLinks = [
    {
      label: "UpWork",
      href: "https://www.upwork.com/freelancers/~019ef7d10eca63d70a",
      icon: SiUpwork,
    },
    {
      label: "Freelancer",
      href: "https://www.freelancer.com/u/fawzibarry?sb=t",
      icon: SiFreelancer,
    },
    {
      label: "ThemeForest",
      href: "https://themeforest.net/user/fawzigood",
      icon: FaPaintBrush,
    },
    {
      label: "RemoteHub",
      href: "https://www.remotehub.com/fawzi.barry",
      icon: FaGlobe,
    },
    {
      label: "Dribbble",
      href: "https://dribbble.com/fawzi_barry",
      icon: SiDribbble,
    },
    {
      label: "Arc",
      href: "https://arc.dev/@fawzibarry?preview=1",
      icon: SiArc,
    },
  ];

  return (
    <>
      <footer
        className="w-full text-center p-6 bg-accent"
        style={{ backgroundColor: "#313131" }}
      >
        <div className="flex flex-wrap items-center justify-center gap-4 mb-6">
          {socialLinks.map(({ label, href, icon: Icon, color }) =>
            href ? (
              <a
                key={label}
                className="inline-flex transition-transform hover:-translate-y-1"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
              >
                <Icon className={`text-2xl ${color}`} />
              </a>
            ) : (
              <span
                key={label}
                className="inline-flex cursor-not-allowed opacity-60"
                aria-label={`${label} link coming soon`}
                title={`Add ${label} link`}
              >
                <Icon className={`text-2xl ${color}`} />
              </span>
            ),
          )}
        </div>
        <div className="flex items-center justify-center mb-6 flex-wrap gap-4">
          {marketplaceLinks.map(({ label, href, icon: Icon }) => (
            <a
              key={label}
              className="inline-flex text-neutral hover:text-primary transition-transform hover:-translate-y-1"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              title={label}
            >
              <Icon className="text-2xl" />
            </a>
          ))}
        </div>

        <div className="w-full h-[2px] bg-gray-600"></div>
        <div className="flex flex-col md:flex-row items-center justify-between mt-4">
          <p>&copy; Copyright All Rights Reserved {year}</p>
          <p>
            Developed by{" "}
            <a
              href="https://www.linkedin.com/in/fawzibarry"
              className="text-primary hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fawzi Barry
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
